// extracted by mini-css-extract-plugin
module.exports = {"container":"Team_container__1SKpV","title":"Team_title__ei8bR","teamGrid":"Team_teamGrid__3uCVa","deco":"Team_deco__6dTRE"};